// @flow

import React, { type Element } from 'react'
import { Box, Button, CircularProgress, Grid } from '@material-ui/core'

type Props = {|
  handleCancel: () => void,
  isLoading: boolean,
  updateDisabled: boolean,
  handleUpdate: () => Promise<void>,
|}

function FieldButtons({
  handleCancel,
  isLoading,
  updateDisabled,
  handleUpdate,
}: Props): Element<typeof React.Fragment> {
  return (
    <Grid container direction="row" justify="flex-end" alignItems="center">
      <Button onClick={handleCancel} color="primary">
        Cancel
      </Button>
      <Box ml={3} display="inline-block" position="relative">
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          disabled={updateDisabled}
        >
          Update
        </Button>
        <CircularProgress
          className={isLoading ? '' : 'hide'}
          size={24}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
          }}
        />
      </Box>
    </Grid>
  )
}

export default FieldButtons
